import styled from "styled-components";

export const PressTitleTableShell = styled.td`
  width: 20rem;
  min-width: 20rem;
  position: relative;
  color: transparent !important;
  font-size: 1.2rem;
  line-height: 1.8rem;
  padding: 1rem;
  border: 0.1rem solid ${({ theme }) => theme.color.neural.gray02};
  vertical-align: top;
  cursor: pointer;
  word-break: break-word;
  overflow-wrap: anywhere;

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);
    .tooltip-container {
      display: block;
    }
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;

  & > div {
    color: ${({ theme }) => theme.color.neural.gray08};
    font-size: 1.2rem;
    line-height: 130%;
    letter-spacing: -0.012rem;
    width: 100%;
    min-width: 0;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  div {
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  span.press-title-keyword {
    font-weight: 400 !important;
  }
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 0.3rem;
  z-index: 100;
  display: none;
  box-sizing: border-box;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-16, 1.6rem);
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16),
    0px 0px 4px 0px rgba(0, 0, 0, 0.12);

  .title-tooltip {
    border: none;
    box-shadow: none;
    padding: 0;
    white-space: normal;
    width: 100%;
    min-width: 0;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .title-tooltip span.press-title-keyword {
    font-weight: 400 !important;
  }
`;

export const RegulatoryTitleBulletList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-6, 0.6rem);
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
`;

export const RegulatoryTitleBulletItem = styled.li`
  position: relative;
  padding-left: 0.7rem;
  list-style: none;
  width: 100%;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const RegulatoryTitleBulletItemText = styled.span`
  display: block;
  width: 100%;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;

  &::before {
    position: absolute;
    left: 0rem;
    top: 0;
    display: block;
    content: "•";
    color: #2a2f37;
    font-size: 1.4rem;
  }
`;

export const RegulatoryTitleNumber = styled.div``;

export const TranslatedId = styled.span`
  color: var(--Color-Text-Progress, #eb8d00);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: -0.012rem;
`;
